<template>
  <div>
  <el-dialog :title="`Transaction ${transactionInfo.id} History`"
    v-model="toggleModal"
    :before-close="handleDialogClosed"
    width="1350"
    top="5%"
  >
    <div
      class="table-wrapper"
      ref="scrollContainer"
      @scroll.passive="handleScroll"
    >
      <el-table
        v-if="hasData"
        :data="transactionInfo.gridData"
        border
      >
        <el-table-column property="action" label="Action" width="300" />

        <el-table-column property="comments" label="Change" width="600">
          <template #default="scope">
            <div class="cell-content">
              {{ scope.row.FEcomment ? getFEcomment(scope.row.FEcomment) : '' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column property="updated_by" label="User" width="200" />
        <el-table-column property="updated_at" label="Date" width="300">
          <template #default="scope">
            {{ scope.row.updated_at ? getDateTimestamp(scope.row.updated_at) : '' }}
          </template>
        </el-table-column>
      </el-table>

      <div v-else class="no-data-message">
        Transaction history does not exist
      </div>
      <div v-if="transactionInfo.pageCount > transactionInfo.currentPage" class="loader">
        Loading more...
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
  export default {
    props: {
      transactionInfo: Object,
      visible: Boolean
    },
    data () {
      return {
        toggleModal: this.visible,
        savedScrollTop: 0
      }
    },
    watch: {
      visible (v) {
        this.toggleModal = v
      },
      // 🔥 Restore scroll after parent updates list
      'transactionInfo.gridData' () {
        this.$nextTick(() => {
          const el = this.$refs.scrollContainer
          if (el) {
            el.scrollTop = this.savedScrollTop
          }
        })
      }
    },
    methods: {
      handleScroll (e) {
        const el = e.target

        // Save scroll before network call
        this.savedScrollTop = el.scrollTop

        if (this.transactionInfo.pageCount <= this.transactionInfo.currentPage) return

        const bottomReached =
          el.scrollTop + el.clientHeight >= el.scrollHeight - 20

        if (bottomReached && !this.transactionInfo.loadingMore) {
          this.$emit('loadMore')
        }
      },

      // Get the date and time in the USA format
      getDateTimestamp (dateParam) {
        const dateObject = new Date(dateParam)
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', second: 'numeric' }
        let timeStamp = dateObject.toLocaleDateString('en-US', options).replace(/,/g, ' ').replace(/\//g, '-')
        return timeStamp
      },
      // Handle the visibiliy value when we try to close the dialog
      handleDialogClosed () {
        this.$emit('closeHistoryDialog')
      },
      getFEcomment (comment) {
        try {
          let data
          comment = comment.replaceAll(' Changed ', ' Changed, ')
          data = comment ? comment.replaceAll(' and ', ' , ').split(', ').filter((c) => !c.includes("'None' to 'None'")).join(', ') : comment
          return data.replaceAll(' Changed, ', ' Changed ')
        } catch (e) {
          return comment
        }
      }
    },
    computed: {
      hasData () {
        return this.transactionInfo.gridData && this.transactionInfo.gridData.length > 0
      }
    }
  }
</script>
<style scoped>
.table-wrapper {
  height: 65vh;
  overflow-y: auto;
}
.cell-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cell-content:hover {
  white-space: normal;
  overflow: visible;
}
.no-data-message {
  text-align: center;
}
.loader {
  text-align: center;
  padding: 16px;
}
</style>
